import React, { useEffect, useState } from 'react'
import { consumirApi } from '../utils/consumoApi'
import { useNavigate } from 'react-router-dom'
import { guardarToken, guardarUsuario, guardarRefreshToken } from './../utils/authUtils.js'
import ErrorAlert from '../components/common/ErrorAlert'
import Modal from '../components/modals/Modal.jsx'
import Form from '../components/forms/Form.jsx'
import Input from '../components/common/Input.jsx'

const Login = () => {
    const [dni, setDni] = useState('')
    const [clave, setClave] = useState('')
    const [nombres, setNombres] = useState("")
    const [apellidos, setApellidos] = useState("")
    const [email, setEmail] = useState("")
    const [mostrarModal, setMostrarModal] = useState(false)
    const [error, setError] = useState('')
    const [errorInsert, setErrorInsert] = useState('')
    const [empresas, setEmpresas] = useState([])
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState("")
    const navigate = useNavigate()

    useEffect(() => {
        const verificarAdmin = async () => {
            const respuesta = await consumirApi('GET', 'users/numero-usuarios')
            const empresas = await consumirApi('GET', 'empresa/empresa')
            if (respuesta.success) {
                const totalUsuarios = respuesta.data.total_usuarios
                if (totalUsuarios == 0) {
                    setMostrarModal(true)
                }
            }
            else {
                setError(respuesta.error)
            }
            setEmpresas(empresas.data)
        }
        verificarAdmin()
    }, [])


    // Función para registrar nuevo usuario
    const registrarUsuario = async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const respuesta = await consumirApi('POST', `users/registrar-admin`, formData)
        if (respuesta.success) {
            setMostrarModal(false)
        } else {
            setErrorInsert(respuesta.error)
        }
    }

    const tryLogin = async (e) => {
        e.preventDefault()
        if (dni === '' || clave === '') {
            setError("Proporcione sus credenciales")
            return
        }
    
        // Si no se selecciona empresa, asignamos un ID por defecto
        const empresaSeleccionadaId = empresaSeleccionada !== 0 ? empresaSeleccionada : null  // Comparar con número
        const razonSocial = empresaSeleccionada !== 0 ? empresas.find(e => e.id === empresaSeleccionada)?.razon_social_empresa : ''  // Comparar con número
    
        const data = { dni_usuario: dni, password: clave, empresa_id: empresaSeleccionadaId }
        const respuesta = await consumirApi('POST', `login`, data)
    
        if (respuesta.success) {
            guardarToken(respuesta.data.token) // Guarda el access token
            guardarRefreshToken(respuesta.data.refresh_token) // Guarda el refresh token
            guardarUsuario(respuesta.data.user) // Guarda el usuario
             // Extraer solo los permisos
             const permisos = respuesta.data.permisos ? respuesta.data.permisos : []
    
             // Guardar solo los permisos en localStorage
             localStorage.setItem('permisos', JSON.stringify(permisos))
            // Registrar la última actividad al momento de login
            localStorage.setItem('ultimaActividad', Date.now())
            
            // Guardar la empresa seleccionada y su razón social
            localStorage.setItem('empresa', empresaSeleccionadaId || 0)
            localStorage.setItem('razon_social', razonSocial)
    
            // Redirige al dashboard
            navigate('/inicio')
        } else {
            setError('Credenciales incorrectas')
        }
    }
    

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <div className="w-full max-w-md p-8 bg-white rounded shadow-lg">
                <img src="/images/logo.png" alt="Logo" className="h-full px-1 py-4" />
                <form>
                    {/* Campo para DNI */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-600" htmlFor="dni">DNI</label>
                        <input
                            id="dni"
                            type="number"
                            maxLength="8"
                            value={dni}
                            className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Ingresa tu DNI"
                            onChange={(e) => setDni(e.target.value)}
                        />
                    </div>

                    {/* Campo para Clave */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-600" htmlFor="clave">Clave</label>
                        <input
                            id="clave"
                            type="password"
                            value={clave}
                            className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Ingresa tu clave"
                            onChange={(e) => setClave(e.target.value)}
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-600" htmlFor="empresa">Empresa</label>
                        <select
                            value={empresaSeleccionada}
                            onChange={(e) => setEmpresaSeleccionada(Number(e.target.value))}  // Convertir a número
                            className="w-full px-4 py-2 mt-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value={0}>Seleccione una empresa</option>  
                            {empresas.length > 0 ? (
                                empresas.map((empresa) => (
                                    <option key={empresa.id} value={empresa.id}>
                                        {empresa.razon_social_empresa}
                                    </option>
                                ))
                            ) : (
                                <option value={0} disabled>No hay empresas disponibles</option>
                            )}
                        </select>

                    </div>
                    <button onClick={tryLogin} className="w-full px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600">
                        Ingresar
                    </button>
                </form>
                {error && <ErrorAlert message={error} />}
            </div>

            {/* Modal Actuazliar ubicacion*/}
            <Modal isOpen={mostrarModal} title="No se encuentra ningun usuario en la BD, registre usuario Administrador" onClose={() => setMostrarModal(false)} >
                <Form onSubmit={registrarUsuario}>
                    <Input name="dni_usuario" value={dni} label="DNI" type='number' onChange={setDni} />
                    <Input name="nombres_usuario" value={nombres} label="Nombres" onChange={setNombres} />
                    <Input name="apellidos_usuario" value={apellidos} label="Apellidos" onChange={setApellidos} />
                    <Input name="email" value={email} label="Email" onChange={setEmail} />
                    {errorInsert && <ErrorAlert message={error} />}
                </Form>
            </Modal>

        </div>
    )
}

export default Login
